import *  as service from '../services/PianoTechnicianServices';

export const FETCH_PIANOTECHNICIAN_LIST_STARTED = 'FETCH_PIANOTECHNICIAN_LIST_STARTED';
export const FETCH_PIANOTECHNICIAN_LIST_SUCCEEDED = 'FETCH_PIANOTECHNICIAN_LIST_SUCCEEDED';
export const FETCH_PIANOTECHNICIAN_LIST_FAILED = 'FETCH_PIANOTECHNICIAN_LIST_FAILED';
export const FIND_PIANOTECHNICIAN_STARTED = 'FIND_PIANOTECHNICIAN_STARTED';
export const FIND_PIANOTECHNICIAN_SUCCEEDED = 'FIND_PIANOTECHNICIAN_SUCCEEDED';
export const FIND_PIANOTECHNICIAN_FAILED = 'FIND_PIANOTECHNICIAN_FAILED';
export const SAVE_PIANOTECHNICIAN_STARTED = 'SAVE_PIANOTECHNICIAN_STARTED';
export const SAVE_PIANOTECHNICIAN_SUCCEEDED = 'SAVE_PIANOTECHNICIAN_SUCCEEDED';
export const SAVE_PIANOTECHNICIAN_FAILED = 'SAVE_PIANOTECHNICIAN_FAILED';
export const RETURN_TO_PIANOTECHNICIAN_LIST = 'RETURN_TO_PIANOTECHNICIAN_LIST';
export const SWITCH_EDIT_TYPE_PIANOTECHNICIAN = 'SWITCH_EDIT_TYPE_PIANOTECHNICIAN';
export const PIANOTECHNICIAN_MODIFIED = 'PIANOTECHNICIAN_MODIFIED';
export const PIANOTECHNICIAN_VALIDATE = 'PIANOTECHNICIAN_VALIDATE';
export const FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_STARTED = 'FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_STARTED';
export const FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_SUCCEEDED = 'FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_SUCCEEDED';
export const FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_FAILED = 'FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_FAILED';

function fetchPianoTechnicianListSucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechnicianList = jsonResponse.pianoTechnicianList;

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: FETCH_PIANOTECHNICIAN_LIST_FAILED,
            message: errorMessage,
        }
    }

    return {
        type: FETCH_PIANOTECHNICIAN_LIST_SUCCEEDED,
        pianoTechnicianList
    }
}

function fetchPianoTechnicianListFailed(response) {
    const errorMessage = 'Failed to retrieve PianoTechnician list.';

    return {
        type: FETCH_PIANOTECHNICIAN_LIST_FAILED,
        message: errorMessage
    }
}

export function fetchPianoTechnicianList() {
    return dispatch => {

        dispatch({
            type: FETCH_PIANOTECHNICIAN_LIST_STARTED
        });

        service
            .getPianoTechnicianList()
            .then(resp => {
                dispatch(fetchPianoTechnicianListSucceeded(resp))
            })
            .catch(error => {
                dispatch(fetchPianoTechnicianListFailed(error))
            });
    }
}

function findPianoTechnicianSucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechnician = jsonResponse.pianoTechnician;
    const originalPianoTechnician = Object.assign({}, pianoTechnician);

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: FIND_PIANOTECHNICIAN_FAILED,
            message: errorMessage,
        }
    }

    return {
        type: FIND_PIANOTECHNICIAN_SUCCEEDED,
        pianoTechnician,
        originalPianoTechnician,
    }
}

function findPianoTechnicianFailed(response) {
    const errorMessage = 'Failed to find PianoTechnician.';

    return {
        type: FIND_PIANOTECHNICIAN_FAILED,
        message: errorMessage
    }
}

export function findPianoTechnician(techniciansId) {
    return dispatch => {

        service
            .findPianoTechnician(techniciansId)
            .then(resp => {
                dispatch(findPianoTechnicianSucceeded(resp))
            })
            .catch(error => {
                dispatch(findPianoTechnicianFailed(error))
            });
    }
}

function savePianoTechnicianSucceeded(response, pianoTechnician) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const message = 'PianoTechnician ' + pianoTechnician.maintenanceType + ' Successful.';
    let updatedPianoTechnician = pianoTechnician;
    const pianoTechnicianList = jsonResponse.pianoTechnicianList;

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: SAVE_PIANOTECHNICIAN_FAILED,
            message: errorMessage,
        }
    }

    if (jsonResponse.pianoTechnician) {
        updatedPianoTechnician = jsonResponse.pianoTechnician;
    }

    return {
        type: SAVE_PIANOTECHNICIAN_SUCCEEDED,
        pianoTechnician: updatedPianoTechnician,
        pianoTechnicianList,
        message,
    }
}

function savePianoTechnicianFailed(response) {
    const errorMessage = 'Action failed: ' + response.message;

    return {
        type: SAVE_PIANOTECHNICIAN_FAILED,
        message: errorMessage
    }
}

export function savePianoTechnician(pianoTechnician, returnUpdateList) {
    return dispatch => {

        service
            .savePianoTechnician(pianoTechnician, returnUpdateList)
            .then(resp => {
                dispatch(savePianoTechnicianSucceeded(resp, pianoTechnician))
            })
            .catch(error => {
                dispatch(savePianoTechnicianFailed(error))
            });
    }
}

export function fetchPianoTechnicianListForCompany(companyId) {
    return dispatch => {
        dispatch({
            type: FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_STARTED
        });

        service
            .getPianoTechnicianListForCompany(companyId)
            .then(resp => {
                dispatch(fetchPianoTechnicianListForCompanySucceeded(resp))
            })
            .catch(error => {
                dispatch(fetchPianoTechnicianListForCompanyFailed(error))
            });
    }
}

function fetchPianoTechnicianListForCompanySucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechnicianList = jsonResponse.pianoTechnicianList;

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_FAILED,
            message: errorMessage,
        }
    }

    return {
        type: FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_SUCCEEDED,
        pianoTechnicianList
    }
}

function fetchPianoTechnicianListForCompanyFailed(response) {
    const errorMessage = 'Failed to retrieve PianoTechnician list for company.';

    return {
        type: FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_FAILED,
        message: errorMessage
    }
}

